var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87633 9.89904L13.4353 14.7957C14.0696 15.213 14.5274 14.9969 14.6854 14.0935L16.9482 1.3804C17.1799 0.273009 16.5942 -0.22925 15.9873 0.0992302L2.70036 6.20766C1.79341 6.64138 1.79869 7.24466 2.53505 7.51347L5.94478 8.78231L13.8387 2.84464C14.2113 2.57522 14.5533 2.72007 14.2726 3.01711",
    fill: "#081B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.6f91bc5988a1a5fe49616476ca7773e5.svg";
export { ForwardRef as ReactComponent };